import { render, staticRenderFns } from "./Agreement.vue?vue&type=template&id=4035644a&scoped=true"
import script from "./Agreement.vue?vue&type=script&lang=js"
export * from "./Agreement.vue?vue&type=script&lang=js"
import style0 from "./Agreement.vue?vue&type=style&index=0&id=4035644a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4035644a",
  null
  
)

export default component.exports